import { render } from "./AppInnerLoading.vue?vue&type=template&id=20787345&scoped=true&lang=pug"
import script from "./AppInnerLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInnerLoading.vue?vue&type=script&setup=true&lang=js"

import "./AppInnerLoading.vue?vue&type=style&index=0&id=20787345&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20787345"]])

export default __exports__